<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search"
          >搜索</el-button
        >
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px">
          <p class="inline-p">
            当前已选择
            <span style="padding: 0 5px">{{ currentRow.length }}</span
            >条数据
          </p>
          <el-button
            style="margin-left: 10px"
            type="primary"
            :disabled="submitDisabled"
            @click="submitAudit"
            >申请退货</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            :disabled="cancelDisabled"
            @click="cancelReturn"
            >取消退货</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="downloadTemplate"
            >下载模板</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="showMakeReturnDeclareOrder"
            >生成退货申报单</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="showMakePurchase"
            >生成退货采购单</el-button
          >
          <el-button style="margin-left: 10px" @click="exportSku"
            >导出订单商品</el-button
          >
          <div
            style="
              float: right;
              padding-right: 30px;
              transform: translateY(10px);
            "
          >
            <el-upload
              class="avatar-uploader"
              action="/file.api"
              accept=".xls, .xlsx"
              :show-file-list="false"
              :data="uploadData"
              :name="uploadName"
              :on-success="handleAvatarSuccess"
            >
              <el-button style="margin-left: 10px" type="primary"
                >导入</el-button
              >
            </el-upload>
            <!-- <el-button style="margin-left: 10px" @click="exportList"
              >导出理货报告</el-button
            > -->
          </div>
        </div>
      </template>
    </customize-page>

    <el-dialog
      width="500px"
      title="生成退货申报单"
      :visible="makeReturnDeclareOrderVisible"
      @close="makeReturnDeclareOrderVisible = false"
    >
      <el-form :inline="true" :model="makeReturnDeclareOrderForm">
        <el-form-item label="导入单号">
          <el-input
            style="width: 350px;"
            autosize
            v-model="makeReturnDeclareOrderForm.importOrderNo"
            placeholder="请输入导入单号"
          />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input
            style="width: 350px;"
            type="textarea"
            autosize
            v-model="makeReturnDeclareOrderForm.merchantOrderNoList"
            placeholder="请输入订单号,多个单号以回车换行"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="makeReturnDeclareOrderVisible = false"
          >取消</el-button
        >
        <el-button type="primary" @click="makeReturn">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="400px"
      title="导出退货订单商品数据"
      :visible="showExportSkuVisible"
      @close="showExportSkuVisible = false"
    >
      <el-form :inline="true" :model="exportSkuForm">
        <el-form-item label="订单号">
          <el-input
            type="textarea"
            autosize
            v-model="exportSkuForm.merchantOrderNoList"
            placeholder="请输入订单号,多个单号以回车换行"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showExportSkuVisible = false">取消</el-button>
        <el-button type="primary" @click="doExportSku">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="1000px"
      title="生成采购订单"
      :visible="makePurchaseVisible"
      @close="makePurchaseVisible = false"
    >
      <el-form :inline="true" :model="makePurchaseForm">
        <el-form-item label="导入单号">
          <el-input
            v-model="makePurchaseForm.importOrderNo"
            placeholder="请输入导入单号"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchPurchaseItem">查询</el-button>
        </el-form-item>
      </el-form>
      <element-table
        headerClassName="stock-table"
        :data="makePurchaseList"
        :columns="makePurchaseColumns"
        :loading="loading"
        border
      ></element-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="makePurchaseVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="makePurchase"
          v-if="makePurchaseList.length > 0"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="导入信息预览" :visible="visible" @close="visible = false">
      <element-table
        headerClassName="stock-table"
        :data="importList"
        :columns="dialogColumns"
        :loading="loading"
        border
      ></element-table>
      <span
        style="line-height: 50px; font-size: 18px"
        v-if="importList.length === 0"
        >当前运单号全部校验通过</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="importLoading"
          @click="importFunc"
          v-if="importList.length"
          >继续导入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import { formatDate } from "@/utils/common";
import ElementTable from "@/components/ElementTable";

import { mapState, mapActions } from "vuex";
import danding from "../../api/danding";
import * as XLSX from "xlsx";
import moment from "moment";

export default {
  components: {
    CustomizePage,
    ElementTable,
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["goodsReturnManage"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      importLoading: false,
      uploadData: {
        _aid: 401,
      },
      makePurchaseForm: {
        importOrderNo: "",
      },
      makeReturnDeclareOrderForm: {
        importOrderNo: "",
        merchantOrderNoList: "",
      },
      exportSkuForm: {
        merchantOrderNoList: "",
      },
      showExportSkuVisible: false,
      makePurchaseColumns: [
        {
          title: "货主id",
          key: "customerId",
          align: "center",
        },
        {
          title: "商品名称",
          key: "skuName",
          align: "center",
        },
        {
          title: "商品料号",
          key: "itemNo",
          align: "center",
        },
        {
          title: "采购数量",
          key: "purchaseQuantity",
          align: "center",
        },
      ],
      dialogColumns: [
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          align: "center",
        },
        {
          title: "运单号",
          key: "mailNo",
          align: "center",
        },
        {
          title: "退货快递公司编码",
          key: "carrierCode",
          align: "center",
        },
        {
          title: "退货运单号",
          key: "returnMailNo",
          align: "center",
        },
        {
          title: "退货原因",
          key: "returnReason",
          align: "center",
        },
        {
          title: "错误信息",
          key: "errorMsg",
          align: "center",
        },
      ],
      makeReturnDeclareOrderVisible: false,
      makePurchaseVisible: false,
      visible: false,
      importList: [],
      makePurchaseList: [],
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "导入单号",
          width: 200,
          key: "importOrderNo",
          align: "center",
        },
        {
          title: "原订单编号",
          key: "merchantOrderNo",
          width: 250,
          align: "center",
          fixed: "left",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style="color:blue"
                onClick={this.showDetail.bind(
                  this,
                  row && row.customsGoodsReturnOrderNo
                )}
              >
                {row.merchantOrderNo}
              </a>
            );
          },
        },
        {
          title: "退货申报编号",
          width: 250,
          key: "customsGoodsReturnOrderNo",
          align: "center",
        },
        {
          title: "原运单号",
          width: 200,
          key: "logisticsNo",
          align: "center",
        },
        {
          title: "退货运单号",
          width: 200,
          key: "mailNo",
          align: "center",
        },
        {
          title: "退货快递",
          width: 120,
          key: "carrierCodeDesc",
          align: "center",
        },
        {
          title: "退货状态",
          width: 130,
          key: "returnStatusDesc",
          align: "center",
          // render: (h, param) => {
          // 	if (!param.row && !param.row.returnStatus) return
          // 	return <div>{this.returnStatusDist[param.row.returnStatus]}</div>
          // }
        },
        {
          title: "入库单号",
          width: 200,
          key: "stockinNo",
          align: "center",
        },
        {
          title: "清单编号",
          width: 200,
          key: "billNo",
          align: "center",
        },
        {
          title: "审核状态",
          width: 130,
          key: "customsAuditStatusDesc",
          align: "center",
        },
        {
          title: "推送信息",
          width: 300,
          key: "customsAuditReturnInfo",
          align: "center",
        },
        {
          title: "电商平台",
          width: 130,
          key: "companyName",
          align: "center",
        },
        {
          title: "申报企业",
          width: 260,
          key: "declareCompanyName",
          align: "center",
        },
        {
          title: "申报关区",
          width: 130,
          key: "portName",
          align: "center",
        },
        {
          title: "创建时间",
          width: 230,
          key: "gmtCreateTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.gmtCreateTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "退货原因",
          width: 200,
          key: "returnReason",
          align: "center",
        },
        {
          title: "操作",
          width: 250,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            //<a style={{color: '#409EFF', padding: '0 10px'}} onClick={this.showDetail.bind(this, row && row.customsGoodsReturnOrderNo)}>查看</a>
            return (
              <div>
                {row.customsAuditStatus !== "CUSTOMS_AUDIT_PASS" &&
                  row.returnStatus !== "RETURN_CANCEL" && (
                    <a
                      style={{ color: "#409EFF", padding: "0 10px" }}
                      onClick={this.cancelReturn.bind(
                        this,
                        row && row.customsGoodsReturnOrderNo
                      )}
                    >
                      取消退货
                    </a>
                  )}
                {(row.customsAuditStatus === "INIT" ||
                  row.customsAuditStatus === "CUSTOMS_AUDIT_REJECT") &&
                  row.returnStatus !== "RETURN_CANCEL" && (
                    <a
                      style={{ color: "#409EFF", padding: "0 10px" }}
                      onClick={this.submitAudit.bind(
                        this,
                        row && row.customsGoodsReturnOrderNo
                      )}
                    >
                      申请退货
                    </a>
                  )}
              </div>
            );
          },
        },
      ],
      returnStatusDist: {
        INIT: "初始化",
        WAIT_RETURN: "待退货",
        RETURN_SUCCESS: "退货完成",
        RETURN_CANCEL: "退货关闭",
      },
      customsAuditStatusDist: {
        INIT: "初始化",
        CUSTOMS_AUDITING: "待总署审核",
        CUSTOMS_AUDIT_PASS: "审核通过",
        CUSTOMS_AUDIT_REJECT: "总署驳回",
      },
      filterObj: {
        merchantOrderNo: "",
        mailNo: "",
        invtNo: "",
        carrierCode: "",
        bizType: "",
        applyTime: [
          new Date(
            parseFloat(
              moment()
                .subtract(7, "day")
                .startOf("day")
                .format("x")
            )
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x")
            )
          ),
        ],
      },
      currentRow: [],
      popover: false,
      cancelDisabled: false,
      submitDisabled: false,
    };
  },
  computed: {
    ...mapState("cs", {
      carrierAllList: "carrierAllList",
    }),
    ...mapState("channelStore", {
      allChannelList: "allChannelList",
    }),
  },
  methods: {
    ...mapActions("danding", [
      "importGoodsReturnExcel",
      "previewGoodsReturnData",
      "queryGoodsReturnList",
      "cancelGoodsReturn",
      "getGoodsReturnDetail",
      "finishGoodsReturn",
      "submitGoodsReturnOrder",
      "exportGoodsReturnOrder",
      "previewMakePurchaseGoods",
      "makePurchaseOrder",
      "makeReturnDeclareOrder",
    ]),
    downloadTemplate() {
      window.open(
        process.env.BASE_URL + "templates/退货单导入.xlsx"
      );
    },
    exportSku() {
      this.showExportSkuVisible = true;
    },
    async doExportSku() {
      const merchantOrderNoList = this.exportSkuForm.merchantOrderNoList;
      const list = merchantOrderNoList.split("\n");
      await this.exportSkuByMerchantOrderNoList(list.map((l) => l.trim()));
      this.$message.success("导出成功");
      this.showExportSkuVisible = false;
      this.exportSkuForm.merchantOrderNoList = "";
    },
    async exportSkuByMerchantOrderNoList(merchantOrderNoList) {
      const data = [
        [
          "运单号",
          "订单号",
          "商品名称",
          "数量",
          "料号",
          "单价",
          "条码",
          "hscode",
          "净重",
          "毛重",
          "创建时间",
        ],
      ];
      const res = await danding.querySkuByMerchantOrderNoList({
        request: {
          merchantOrderNoList: merchantOrderNoList,
        },
      });
      res.items.forEach((item) => {
        data.push([
          item.mailNo,
          item.merchantOrderNo,
          item.skuName,
          item.quantity,
          item.itemNo,
          item.price,
          item.barcode,
          item.hsCode,
          item.netWeight,
          item.grossWeight,
          item.gmtCreate,
        ]);
      });
      let workSheet = "";
      await (workSheet = XLSX.utils.aoa_to_sheet(data));
      let workBook = XLSX.utils.book_new();
      await XLSX.utils.book_append_sheet(workBook, workSheet, "1");
      await XLSX.writeFile(workBook, "退货商品数据导出.xlsx");
    },
    searchPurchaseItem() {
      if (!this.makePurchaseForm.importOrderNo) {
        this.$message.error("请输入采购单号");
        return;
      }
      this.loading = true;
      this.previewMakePurchaseGoods({
        importOrderNo: this.makePurchaseForm.importOrderNo,
      }).then((res) => {
        this.loading = false;
        this.makePurchaseList = res.value ? res.value : [];
      });
    },
    makePurchase() {
      this.$confirm("确认创建退货采购单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((action) => {
          this.makePurchaseOrder({
            importOrderNo: this.makePurchaseForm.importOrderNo,
          }).then((res) => {
            if (res.value) {
              this.$router.push({ name: "purchaseOrder" });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    makeReturn() {
      this.$confirm("确认创建退货申报单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((action) => {
          const merchantOrderNoList = this.makeReturnDeclareOrderForm
            .merchantOrderNoList;
          const list = merchantOrderNoList.split("\n").filter((v) => v.trim());
          if (list.length === 0) {
            this.$message.warning(`请输入订单号`);
            return;
          }
          if (!this.makeReturnDeclareOrderForm.importOrderNo) {
            this.$message.warning(`请输入导入单号`);
            return;
          }
          this.makeReturnDeclareOrder({
            importOrderNo: this.makeReturnDeclareOrderForm.importOrderNo,
            merchantOrderNoList: list,
          }).then((res) => {
            if (res.value) {
              this.makeReturnDeclareOrderVisible = false;
              this.$router.push({ name: "returnDeclareOrderManage" });
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 提交退货申请
    submitAudit(id) {
      let list = [];
      if (typeof id === "string") {
        list.push(id);
      } else {
        this.currentRow.map((v) => {
          // 退货状态为初始化状态可以申请退货
          list.push(v.customsGoodsReturnOrderNo);
        });
      }
      if (list.length === 0) {
        this.$message.warning(`请选择支持提交退货申请的订单`);
        return;
      }
      this.$confirm("确认将选中的订单提交审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((action) => {
          this.submitGoodsReturnOrder({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
            this.fetch();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 取消退货申请
    cancelReturn(id) {
      let list = [];
      if (typeof id === "string") {
        list.push(id);
      } else {
        this.currentRow.map((v) => {
          // 退货状态为初始化状态和待退货状态可以取消退货申请
          list.push(v.customsGoodsReturnOrderNo);
        });
      }
      if (list.length === 0) {
        this.$message.warning(`请选择支持取消退货申请的订单`);
        return;
      }
      this.$confirm("是否确定取消退货订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then((res) => {
          this.cancelGoodsReturn({
            request: { customsGoodsReturnOrderNos: list },
          }).then((res) => {
            if (res.failureList.length) {
              this.$message.warning(
                `有${res.failureList.length}条数据提交失败`
              );
            }
            this.fetch();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 导入数据
    handleAvatarSuccess(res, file) {
      let fileUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.previewGoodsReturnData({ fileUrl }).then((res) => {
        this.loading = false;
        let list = res.goodsReturnOrderInfos || [];
        this.importList = list;
        this.visible = true;
      });
    },
    showMakePurchase() {
      this.makePurchaseVisible = true;
    },
    showMakeReturnDeclareOrder() {
      this.makeReturnDeclareOrderVisible = true;
    },
    importFunc() {
      let list = this.importList.filter((item) => {
        return !item.errorMsg;
      });
      if (list.length === 0) {
        this.$message.warning("暂无有效数据");
        return;
      }
      this.importLoading = true;
      this.importGoodsReturnExcel({
        request: {
          goodsReturnOrderImportInfos: this.importList.map((li) => ({
            ...li,
            sku: li.sku
              ? li.sku
                  .split(",")
                  .filter((s) => s)
                  .join(",")
              : "",
          })),
        },
      })
        .then((res) => {
          if (res) {
            this.reset();
            this.importLoading = false;
          }
          this.visible = false;
        })
        .catch((err) => {
          this.visible = false;
          this.importLoading = false;
        });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        let start = filterParams.applyTime[0],
          end = filterParams.applyTime[1];
        filterParams.gmtCreateStart = new Date(start).getTime();
        filterParams.gmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      if (filterParams.merchantOrderNoList) {
        filterParams.merchantOrderNoList = filterParams.merchantOrderNoList.split(
          ","
        );
      }
      if (filterParams.importOrderNoList) {
        filterParams.importOrderNoList = filterParams.importOrderNoList.split(
          ","
        );
      }
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      this.queryGoodsReturnList(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.cdGoodsReturnOrderDetailList || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
      if (this.currentRow.length) {
        // 退货关闭状态无法申请退货和取消退货
        let bool = false;
        this.currentRow.map((v) => {
          if (v.returnStatus === "RETURN_CANCEL") {
            bool = true;
          }
        });
        // 待口岸审核、待总署审核、总署审核通过 不可申请退货
        let bool2 = false;
        this.currentRow.map((v) => {
          if (
            v.customsAuditStatus === "CUSTOMS_AUDITING" ||
            v.customsAuditStatus === "CUSTOMS_AUDIT_PASS"
          ) {
            bool2 = true;
          }
        });
        // 总署审核通过不可取消退货
        let bool3 = false;
        this.currentRow.map((v) => {
          if (v.customsAuditStatus === "CUSTOMS_AUDIT_PASS") {
            bool3 = true;
          }
        });

        this.submitDisabled = bool || bool2;
        this.cancelDisabled = bool || bool3;
      } else {
        this.submitDisabled = false;
        this.cancelDisabled = false;
      }
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "导入单号",
              model: "importOrderNoList",
              type: type.INPUT,
            },
            {
              label: "原订单编号",
              model: "merchantOrderNoList",
              type: type.INPUT,
            },
            {
              label: "退货运单号",
              model: "mailNo",
              type: type.INPUT,
            },
            {
              label: "原运单号",
              model: "logisticsNo",
              type: type.INPUT,
            },
            {
              label: "入库单号",
              model: "stockinNo",
              type: type.INPUT,
            },
            {
              label: "订单渠道",
              model: "bizType",
              type: type.SELECT,
              props: {
                data: this.allChannelList,
              },
            },
            {
              label: "退货快递",
              model: "carrierCode",
              placeholder: "支持模糊搜索",
              type: type.SELECT,
              props: {
                data: this.calculateArr(this.carrierAllList),
              },
            },
            {
              label: "退货状态",
              model: "returnStatus",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "INIT",
                    label: "初始化",
                  },
                  {
                    value: "WAIT_RETURN",
                    label: "待退货",
                  },
                  {
                    value: "RETURN_SUCCESS",
                    label: "退货完成",
                  },
                  {
                    value: "RETURN_CANCEL",
                    label: "退货关闭",
                  },
                ],
              },
            },
            {
              label: "审核状态",
              model: "customsAuditStauts",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "INIT",
                    label: "初始化",
                  },
                  {
                    value: "CUSTOMS_AUDITING",
                    label: "待总署审核",
                  },
                  {
                    value: "CUSTOMS_AUDIT_PASS",
                    label: "总署审核通过",
                  },
                  {
                    value: "CUSTOMS_AUDIT_REJECT",
                    label: "总署驳回",
                  },
                ],
              },
            },
            {
              label: "创建时间",
              model: "applyTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
            {
              label: "是否未生成退货申报单",
              model: "hasCreateDeclareOrder",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: null,
                    label: "全部",
                  },
                  {
                    value: "1",
                    label: "是",
                  },
                ],
              },
            },
          ],
        },
      ];
    },
    // 将快递列表转为可供select组件使用的数组
    calculateArr(arr) {
      if (!arr || !arr.length) return;
      let theArr = [];
      arr.map((v) => {
        theArr.push({
          value: v.code,
          label: v.name,
        });
      });
      return theArr;
    },
    // 转到详情页
    showDetail(id) {
      if (!id) return;
      this.$router.push({
        name: "goodsReturnDetail",
        params: { id: id || 0 },
      });
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateStart = new Date(
          filterParams.applyTime[0]
        ).getTime();
        filterParams.gmtCreateEnd = new Date(
          filterParams.applyTime[1]
        ).getTime();
        delete filterParams.applyTime;
      }
      this.exportGoodsReturnOrder({
        request: {
          ...filterParams,
          // currentPage: 1,
          // pageSize: 9999
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
  },
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
